<template>
    <component
        :is="isDevelopersOrientedCountry ? BaseLink : 'div'"
        data-interface-section="empty-my-games"
        target="_blank"
        :externalTo="DEVELOPERS_LANDPAGE_PATH"
    >
        <ul :class="$style.cards">
            <li
                v-for="(promo, index) in promosInfo"
                :key="index"
                :class="$style.card"
            >
                <img
                    :class="$style.img"
                    :src="promo.imgSrc"
                    :alt="promo.imgAlt"
                />
                <Typography
                    type="paragraph"
                    size="s"
                    :class="[$style.description, $style.mobile]"
                    :responsive="false"
                >
                    <!-- eslint-disable vue/no-v-html -->
                    <p v-html="promo.description" />
                    <!-- eslint-enable vue/no-v-html -->
                </Typography>
                <Typography
                    type="paragraph"
                    size="xs"
                    :class="[$style.description, $style.tabletPlus]"
                    :responsive="false"
                >
                    <!-- eslint-disable vue/no-v-html -->
                    <p v-html="promo.description" />
                    <!-- eslint-enable vue/no-v-html -->
                </Typography>
                <template v-if="index !== promosInfo.length - 1">
                    <div :class="$style.separator" />
                    <div :class="[$style.separator, $style.left]" />
                </template>
            </li>
        </ul>
    </component>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import BaseLink from '@/components/BaseLink.vue'
import EyesImage from '@/components/images/eyes.webp'
import Typography from '@/components/Typography.vue'
import { useTr } from '@/composables/use-tr'
import { DEVELOPERS_LANDPAGE_PATH } from '@/router/navigation-constants'

import CrossImage from './images/cross.webp'
import SnowFlakeImage from './images/snow-flake.webp'

const props = defineProps<{
    currentCountry: string
}>()

const tr = useTr()

const isDevelopersOrientedCountry = computed(() => ['RU', 'AM', 'UA', 'GE', 'CY'].includes(props.currentCountry))
const promosInfo = computed(() => {
    let firstDec = tr('promos.descriptionPlayGame')
    let secondDec = tr('promos.descriptionDownload')
    let thirdDec = tr('promos.descriptionEnjoyGame')

    if (isDevelopersOrientedCountry.value) {
        firstDec = tr('promos.descriptionAddGame')
        secondDec = tr('promos.descriptionReach')
        thirdDec = tr('promos.descriptionPublish')
    }

    return [
        { imgSrc: CrossImage, imgAlt: tr('promos.altFirstPromo'), description: firstDec },
        { imgSrc: EyesImage, imgAlt: tr('promos.altSecondPromo'), description: secondDec },
        { imgSrc: SnowFlakeImage, imgAlt: tr('promos.altThirdPromo'), description: thirdDec },
    ]
})
</script>
<style module>
.cards {
    display: flex;
    flex-shrink: 0;
    overflow-x: auto;
    gap: 17px;
}

.cards {
    align-items: center;
    scrollbar-width: none;
    overflow: auto;
    scroll-snap-type: x mandatory;
    padding-left: var(--global-wide-scroller-padding-left);
    padding-right: var(--global-wide-scroller-padding-right);
}

.cards li {
    display: flex;
    flex-shrink: 0;
}

.card {
    display: flex;
    gap: 12px;
    background-color: var(--carbon-300);
    border-radius: 12px;
    height: 48px;
    padding: 4px 12px;
    align-items: center;
    position: relative;
}

.description {
    color: var(--white-80);
}

.img {
    width: 44px;
    height: 44px;
}

/* separator */

.separator {
    position: absolute;
    width: 25px;
    right: -5px;
    height: 10px;
    transform: rotate(90deg);
}

.separator.left {
    right: -37px;
    transform: rotate(-90deg);
}

.separator::before,
.separator::after {
    content: '';
    position: absolute;
    width: 13px;
    height: 30px;
    background-color: transparent;
    bottom: 0;
    box-shadow: 0 -10px 0 0 var(--carbon-300);
}

.separator::before {
    left: 0;
    border-top-right-radius: 25px;
}

.separator::after {
    right: 0;
    border-top-left-radius: 25px;
}

.tabletPlus {
    display: none;
}

@media (--tablet-plus) {
    .mobile,
    .separator {
        display: none;
    }

    .card {
        padding: 0;
        border-radius: 0;
        background-color: transparent;
        gap: 8px;
    }

    .tabletPlus {
        display: block;
    }
}

@media (--desktop-small-plus) {
    .description {
        color: #e6d4ff;
    }

    .cards {
        gap: 32px;
    }
}
</style>
